import {UCUMUnit} from "../../../helper/UCUMUnit";

export const initialState = () => ({
  DSSMedicationSchedules: [],
  medicationClasses: [],
  patientQuestionnaires: [],
  auditTrails: { edges: [] },
  titrationSchemes: [],
  algorithm: [],
  missingDSSPopupMessage: '',
  prescriptionRecentlyUpdatedWarning: false,
  schedulesToBeDeleted: 0,
  DSSFirstLoad: {
    DSS: true,
    screens: []
  },
  DSSLastAuditTrails: []
});

export const newMedicationSchedule = () => ({
  id: '',
  administration: 'pill',
  name: '',
  dosage: {
    doseAndRate: [
      {
        id: null,
        doseQuantity: {
          value: 0,
          code: UCUMUnit.MG.unit,
          unit: UCUMUnit.MG.unit,
        },
      },
    ],
  },
  medication: {
    classes: [],
    medicationType: 'cardio',
    name: '',
  },
  schedule: {
    intervals: [{ interval: 'P1D', intervalOn: true }],
    monthsOfYear: [],
    daysOfMonth: [],
    daysOfWeek: [],
    weeksOfMonth: [],
    weeksOfYear: [],
  },
  intakeMoments: [],
  afternoonAmount: 0,
  eveningAmount: 0,
  noonAmount: 0,
  morningAmount: 0,
  notes: '',
  combinedDrugs: [],
  isNew: true,
  guidelines: [],
});

export default initialState();
